"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "ScrollSync", {
  enumerable: true,
  get: function get() {
    return _ScrollSync["default"];
  }
});
exports["default"] = void 0;

var _ScrollSync = _interopRequireDefault(require("./ScrollSync"));

var _default = _ScrollSync["default"];
exports["default"] = _default;